import type { GoogleProposals } from '../googleProposals';
import './google-proposal-editor.css';
import { GoogleProposalPaste } from './GoogleProposalPaste';

interface Props { value: GoogleProposals; onChange: (value: GoogleProposals) => void; disabled: boolean }

const fields = [
  { key: 'headlines', label: 'Título', title: 'Títulos', maximum: 15, length: 30, minimum: 3 },
  { key: 'descriptions', label: 'Descrição', title: 'Descrições', maximum: 4, length: 90, minimum: 2 },
  { key: 'keywords', label: 'Palavra-chave', title: 'Palavras-chave', maximum: 1000, length: 80, minimum: 1 },
] as const;

export function GoogleProposalFields({ value, onChange, disabled }: Props) {
  function update(key: keyof GoogleProposals, index: number, text: string) {
    onChange({ ...value, [key]: value[key].map((item, position) => position === index ? text : item) });
  }
  return <div className="campaign-review-columns google-proposal-fields">
    {fields.map(field => <fieldset key={field.key} disabled={disabled}>
      <legend>{field.title} ({value[field.key].length}/{field.maximum})</legend>
      <p>Mínimo {field.minimum}. Até {field.length} caracteres por item.</p>
      <GoogleProposalPaste label={field.title} disabled={disabled}
        onApply={items => onChange({ ...value, [field.key]: items })} />
      {value[field.key].map((text, index) => <div className="google-proposal-row" key={index}>
        <label htmlFor={`google-${field.key}-${index}`}>{field.label} {index + 1}</label>
        <textarea id={`google-${field.key}-${index}`} rows={field.key === 'descriptions' ? 3 : 2}
          value={text} maxLength={field.length} onChange={event => update(field.key, index, event.target.value)} />
        <div><small>{text.length}/{field.length}</small>
          <button type="button" aria-label={`Remover ${field.label.toLowerCase()} ${index + 1}`}
            onClick={() => onChange({ ...value, [field.key]: value[field.key].filter((_, position) => position !== index) })}>Remover</button>
        </div>
      </div>)}
      <button type="button" className="google-proposal-secondary" disabled={value[field.key].length >= field.maximum}
        onClick={() => onChange({ ...value, [field.key]: [...value[field.key], ''] })}>Adicionar {field.label.toLowerCase()}</button>
    </fieldset>)}
  </div>;
}
